import React from 'react';

const NotesTab: React.FC = () => {
  return (
    <div>
      <p>Notes content will go here.</p>
    </div>
  );
};

export default NotesTab;